export const SUPPORT_VOTED_TOPICS = 'support-voted-topics';
export const CHUNKS_COUNT = 3;
export const MIN_PER_CHUNK = 3;
